import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { useTranslation } from 'react-i18next';

import OthelloVersionWeb from "../componentsothello/OthelloVersionWeb.jsx";

// Material Dashboard 2 PRO React components
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import MDInput from "../components/MDInput";
import MDButton from "../components/MDButton";

import Link from "@mui/material/Link";

import Button from "../components/Button.jsx";

import { CircularProgress } from "@mui/material";

import Grid from "@mui/material/Grid";


export default function RememberPass({ ...props }) {
    // const { classes, t } = this.props;
    const { t } = useTranslation();

    const navigate = useNavigate();

    const [submitted, setsubmitted] = useState(false);
    const [error, seterror] = useState(0); 
    const [modoapps, setmodoapps] = useState(window.location.pathname.indexOf("/authapps") !== -1)

    const [loading, setLoading] = useState(false);

    const handleClick = (event) =>
    {
        event.preventDefault();

        let formulario = document.getElementById('formlogin');
        let data = new FormData(formulario);

        setLoading(true);

        fetch('api/Data/RecordarPassUsuario', {
            method: 'POST',
            body: data,

        }).then(response => response.json()).then(res => {
            //Si hubo error
            if (!res)
            {
                setLoading(false);            
                setsubmitted(true);
                seterror(1);
            }
            else {
                if (modoapps)
                    window.location.assign('/authapps/loginapp');
                    //navigate('/authapps/loginapp');
                //this.props.history.push('/authapps/loginapp');
                else
                    window.location.assign('/auth/login');
                    //navigate('auth/login');
                //this.props.history.push('/auth/login');
                //window.location.assign('/admin/dashboard');
            }
        }).catch(error => {
            setsubmitted(true);
            seterror(2);
        });
    }

    const handleCancekClick = () =>
    {
        if (modoapps)
            window.location.assign('/authapps/loginapp');                 
        else
            window.location.assign('/auth/login');
       
        //props.history.push('/auth/login');
    }

    return (
            <form id="formlogin">
            <MDBox >
                <MDBox mb={2}>
                    <MDInput id="email" name="email" type="text" label="Usuario o Email" autocompletado={true} fullWidth fullWidth error={submitted && error == 1 ? true : false} />
                </MDBox>
                <MDBox mt={4} mb={1}>
                    <Grid container>
                        <Grid item xs={6}>
                            <MDButton variant="gradient" color="info" size="large" onClick={(e) => handleCancekClick(e)} fullWidth>
                                Cancelar
                            </MDButton>                            
                        </Grid>
                        <Grid item xs={0.5} >
                        </Grid>                        
                        <Grid item xs={5.5} >                           
                            <MDButton variant="gradient" color="info" size="large" onClick={(e) => handleClick(e)} fullWidth>
                                Entrar
                            </MDButton>
                        </Grid>
                    </Grid>
                </MDBox>
                {loading ? <MDBox mt={2} mb={1} justifyContent={'center'}><center> <CircularProgress /></center> </MDBox> : ""}                
                <MDBox mt={1} textAlign="center">
                    <MDTypography variant="button" color="text">
                        Alguna duda, contacte con nosotros?{" "}
                        <Link href={"https://atmovilidad.com/"} target="_blank">
                            <MDTypography
                                variant="button"
                                color="info"
                                fontWeight="medium"
                                textGradient>
                                Accede a nuestra web
                            </MDTypography>
                        </Link>
                    </MDTypography>
                </MDBox>
                <MDBox py={3} px={3} textAlign="center" fontSize={12} >
                    <OthelloVersionWeb />
                </MDBox>
            </MDBox>
            </form>
        );
}
